import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {faShieldCheck} from "@fortawesome/pro-solid-svg-icons";
import {CloudNumberComponent} from "../design/cloud-number/cloud-number.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrl: './loading-screen.component.scss',
  host: {
    class: 'h-full'
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CloudNumberComponent,
    FaIconComponent
  ]
})
export class LoadingScreenComponent implements OnInit {

  @Input() loadingMessages: string[] = [];
  @Input() loadingDuration = 10000; // Default duration 10 seconds
  @Input() checkName = "Check";
  @Input() loadingText = "Wir überprüfen Ihre Projektdaten";

  currentLoadingMessageIndex = 0;
  currentLoadingMessage = this.loadingMessages[0];

  ngOnInit(): void {
    // Loading messages display
    this.currentLoadingMessageIndex = 0;
    this.currentLoadingMessage = this.loadingMessages[0];

    let intervalId = setInterval(() => {
      this.currentLoadingMessageIndex++;

      if (this.currentLoadingMessageIndex < this.loadingMessages.length) {
        this.currentLoadingMessage = this.loadingMessages[this.currentLoadingMessageIndex];
      } else {
        clearInterval(intervalId); // Stop updating once the last message is shown
      }
    }, this.loadingDuration);
  }

  protected readonly faShieldCheck = faShieldCheck;
}
